var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Node',{staticClass:"integration-node",attrs:{"node-id":_vm.nodeId,"icon":"file-code-outline","shape":"right-pointer"}})}
var staticRenderFns = []

export { render, staticRenderFns }